import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref, watch } from "vue";
import DialogLayout from "@/components/common/DialogLayout.vue";

import {
  ReservationDetail,
  ReservationIdentifiers,
  StagePaymentMethod,
} from "@/models/dto";
import { getAllowedBalancePaymentMethods } from "@/utils/payment";
import MakeCreditCardPayment from "./MakeCreditCardPayment.vue";
import MakeBankPayment from "./MakeBankPayment.vue";
import MakeCheckPayment from "./MakeCheckPayment.vue";
import { PaymentMethodTypeKey } from "@/utils/enum";
import { useGoogleAnalytics, Event } from "@/composables/useGoogleAnalytics";

export default /*#__PURE__*/_defineComponent({
  __name: 'MakePaymentDialog',
  props: {
    value: { type: Boolean },
    reservationIdentifiers: null,
    reservation: null,
    balancePaymentMethods: null,
    isBookingContact: { type: Boolean }
  },
  emits: ["update:value", "payment-success"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
  reservationIdentifiers: ReservationIdentifiers[];
  reservation: ReservationDetail;
  balancePaymentMethods: StagePaymentMethod[];
  isBookingContact: boolean;
};

const { proxy } = getCurrentInstance()!;
const t = proxy.$t.bind(proxy);




const dialogIsOpen = ref(false);

watch(
  () => props.value,
  (newVal) => {
    dialogIsOpen.value = newVal;
    emit("update:value", newVal);
  },
  { immediate: true }
);



const activePaymentMethods = computed(() => {
  return getAllowedBalancePaymentMethods(props.balancePaymentMethods);
});

const close = () => {
  dialogIsOpen.value = false;
  selectedTab.value = 0;
  emit("update:value", false);
};

const handleDialogInput = (value: boolean) => {
  dialogIsOpen.value = value;
  emit("update:value", value);
  if (!value) {
    close();
  }
};

const handlePaymentSuccess = () => {
  emit("payment-success");

  close();
};

const selectedTab = ref(0);
const PAYMENT_TAB_MAP = {
  credit_card: {
    key: 'credit_card',
    label: t("paymentInformation.CREDIT_CARD"),
    component: MakeCreditCardPayment,
  },
  check: {
    key: 'check',
    label: t("paymentInformation.CHECK"),
    component: MakeCheckPayment,
  },
  ach: {
    key: 'ach',
    label: t("paymentInformation.BANK_TRANSFER"),
    component: MakeBankPayment,
  },
};
const PAYMENT_TAB_ORDER = ["credit_card", "check", "ach"];

const paymentTabs = computed(() =>
  PAYMENT_TAB_ORDER
    .filter((key) => activePaymentMethods.value.includes(key as PaymentMethodTypeKey))
    .map((key) => ({ ...PAYMENT_TAB_MAP[key], key }))
);


const analytics = useGoogleAnalytics()
const trackPaymentTab = (selectedKey: string): void => {
  analytics.trackEvent(Event.PaymentTab, {
    paymentTab: selectedKey,
  })
}

 // Track tab changes, but only for check and ach tabs (not credit card which is default)
watch(selectedTab, (newTabIndex, oldTabIndex) => {
  if (oldTabIndex !== undefined && newTabIndex >= 0) {
    const selectedPaymentMethod = paymentTabs.value[newTabIndex];
    const selectedKey = selectedPaymentMethod?.key;

    if (selectedKey === 'check' || selectedKey === 'ach') {
      trackPaymentTab(selectedKey);
    }
  }
});



return { __sfc: true,proxy, t, props, dialogIsOpen, emit, activePaymentMethods, close, handleDialogInput, handlePaymentSuccess, selectedTab, PAYMENT_TAB_MAP, PAYMENT_TAB_ORDER, paymentTabs, analytics, trackPaymentTab, DialogLayout }
}

})